// @flow
import {IOError} from "./IOError";
import type {ProtoFetchOptions} from "../Fetchers/FetcherBase";

export class HTTPStatusError extends IOError {
    request: {url: URL, options: ProtoFetchOptions};
    response: string;
    status: number;
    constructor(request: {url: URL, options: ProtoFetchOptions}, response: string, status: number) {
        super(`Erroneous status (${status}) while processing request (${request.url.toString()})`);
        this.request = request;
        this.response = response;
        this.status = status;
    }
}
